import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: '#fff',
        color: '#666'
      },
    },
    MuiButton: {
      outlined: {
        alignSelf: 'flex-end',
      },
      containedPrimary: {
        width: '270px',
      }
    },
    MuiDrawer: {
      paper: {
        overflowX: 'hidden'
      }
    },
    MuiFormControlLabel: {
      label: { 
        fontSize: '15px',
        fontWeight: 300
      }
    },
    MuiFormControl: {
      root: {
        marginBottom: '24px'
      }
    },
    MuiMenu: {
      list: {
        overflowX: 'scroll' 
      }
    },
    MuiMenuItem: {
      root: {
        overflow: 'unset'
      }
    },
    MuiSlider: {
      rail: {
        height: 7,
        borderRadius: 25,
        width: '102%'
      },
      track: {
        height: 7,
        borderRadius: 25
      },
      mark: {
        height: 4,
        width: 4,
        marginTop: 1,
        borderRadius: '50%'
      },
      thumb: {
        width: 20,
        height: 20,
        marginTop: -7
      }
    },
    MuiTabs: {
      flexContainer: {
        justifyContent: 'center'
      }
    }
  },
  palette: {
    primary: {
      main: '#4212E3'
    },
    secondary: {
      main: '#00A5EE'
    },
    gray: {
      main: '#BCBCCB',
      dark: '#666666',
      light: '#F0F0F7'
    },
    white: {
      main: '#fff'
    },
    gray_label: {
      color: '#43425D'
    }
  },
  props: {
    MuiTypography: {
      variantMapping: {
        userName: 'span',
        body1: 'span'
      }
    }
  }
})

export default theme
